import { render, staticRenderFns } from "./GroupEventItem.vue?vue&type=template&id=8001ea52&scoped=true&"
import script from "./GroupEventItem.vue?vue&type=script&lang=js&"
export * from "./GroupEventItem.vue?vue&type=script&lang=js&"
import style0 from "./GroupEventItem.vue?vue&type=style&index=0&id=8001ea52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8001ea52",
  null
  
)

export default component.exports